import React, { ReactElement } from "react";
import { AuthPageLayout } from "@/pages/auth/components";
import { ForgotPasswordForm, ForgotPasswordLinkSection } from "./";
import { Container, Grid } from "@mui/material";

/**
 * ForgotPassword component for password recovery
 * Displays a form for users to request password reset and related links
 * @returns The forgot password page component
 */
export const ForgotPassword = (): ReactElement => {
  return (
    <AuthPageLayout>
      <Container sx={{ width: "100%" }}>
        <Grid container spacing={1} sx={{ width: "100%" }}>
          <Grid size={{ xs: 12 }}>
            <ForgotPasswordForm />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <ForgotPasswordLinkSection />
          </Grid>
        </Grid>
      </Container>
    </AuthPageLayout>
  );
};
